import { CustomAppLayout } from '../../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useState } from 'react';
import { useRouter } from '../../../router';
const _preserve = React.version;
//import { useStore } from '../store';
import { useGlobalState } from '../../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../context/useStoreAdmin';

import { Button, Checkbox, Form, FormField, Link, Pagination, Select, SpaceBetween, Spinner, Table, TextFilter } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { mdiAccountMultipleCheckOutline, mdiFileExcel, mdiFilterVariant, mdiMagnify, mdiVectorIntersection, mdiVectorUnion } from '@mdi/js';
import Icon from '@mdi/react';
import * as XLSX from "xlsx";
import Favorites from '../../../../../components/extras/Favorites';
import UserAvatar from '../../../../../components/extras/UserAvatar';
import SelectCharges from '../../../../../components/selects/SelectCharges';
import SelectCheck from '../../../../../components/selects/selectChecks';
import SelectGroup from '../../../../../components/selects/selectGroups';
import SelectPaging from '../../../../../components/selects/selectPaging';
import SelectUserType from '../../../../../components/selects/selectUserTypes';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { btnIconForm, ItemFilter, ItemUser } from '../../../../../resources/types';
import { addNotification, addNotificationStatus, buildBreadcrumbItems, formatCurrency, getCookie, getUrlVersion, setData, setLoading, setParameters } from '../../../../commons/functions';

export const DownloadsUsers = () => {

    const [userCount, setUserCount] = useState<number>(0);
    const { menu, parameters } = useGlobalState();
    const [users, setUsers] = useState<ItemUser[]>([]);
    const [filter, setFilter] = useState<ItemFilter | undefined>(undefined);
    const [loadingCount, setLoadingCount] = useState<boolean>(false);
    const [filteringText, setFilteringText] = useState("");

    const exportToExcel = () => {
        const ws = XLSX.utils.json_to_sheet(filtered);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Usuarios");
        XLSX.writeFile(wb, "users.xlsx");
    };
    useGlobalState();
    const handleGetCounter = async () => {
        try {
            setLoadingCount(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/users/users.count',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify({
                    intersection: filter?.intersection,
                    idGroups: filter?.idGroups,
                    //idStatuses: filter?.idStatuses,
                    idCharges: filter?.idCharges,
                    idChecks: filter?.idChecks,
                    idUserTypes: filter?.idUserTypes
                }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data.code == 0) {
                setUserCount(data.count);
            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally { setLoadingCount(false) }
    }
    const { navigate } = useRouter();

    const handleRefresh = async () => {
        if (filter) {
            try {
                setLoading(true);
                const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-routing': '/private/reports/users/list',
                        'JWT': getCookie("JWT"),

                    },
                    body: JSON.stringify(filter)
                });

                if (!response.ok) {
                    throw new Error(`HTTP error: ${response.status}`);
                }

                const data = await response.json();
                if (data && data.users) {
                    setUsers(data.users)
                }
                //storeAdmin(data);
                // Create a new list with updated 'accesos' field before setting it to state

            } catch (error) {
                console.error('Error fetching users:', error);
            } finally {
                setLoading(false);
            }
        }
    };
    useEffect(() => {
        //handleRefresh()
        //handleGetCounter();

    }, [filter]);

    const totalFilters = filter ? (filter?.idCharges ? filter?.idCharges?.length : 0) +
        (filter?.idUserTypes?.length ? filter?.idUserTypes?.length : 0) +
        (filter?.idChecks?.length ? filter?.idChecks?.length : 0) +
        //(filter?.idStatuses?.length ? filter?.idStatuses?.length : 0) +
        (filter?.idGroups?.length ? filter?.idGroups?.length : 0) : 0;

    const activeOptions = [
        { label: "Indiferente", value: "-1" },
        { label: "Activos", value: "1" },
        { label: "Inactivos", value: "0" },
    ]

    const [currentPageIndex, setCurrentPageIndex] = useState(1);

    const filtered: ItemUser[] = users.filter((item) => {
        const searchWords = filteringText.toLowerCase().split(/\s+/).filter(Boolean);
        const text = [item.displayName, item.RUT, item.idUser.toString(), item.phone1, item.email].join(" ").toLowerCase().replace(/[^a-z0-9]/g, "");
        return searchWords.every((word) => text.includes(word.replace(/[^a-z0-9]/g, "")));
    });
    const paginated = filtered.slice((currentPageIndex - 1) * parameters.pageSize, currentPageIndex * parameters.pageSize);

    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <SpaceBetween size="s">
                    <Header variant="h2"
                        info=
                        {users && users.length > 0 && (
                            <>{users.length} usuarios</>
                        )}



                        actions={
                            <>
                                <Favorites />
                            </>
                        }
                    >Reporte de usuarios</Header>
                    <Header variant='h3'>
                        Filtros
                        {totalFilters > 0 ? (<>{' '}<Icon path={mdiFilterVariant} size={1} />{totalFilters}</>) : null}
                        {" "}
                        {totalFilters > 0 ?
                            loadingCount ? <Spinner /> : <><Icon path={mdiAccountMultipleCheckOutline} size={1} />{userCount}</>
                            : null}


                    </Header>
                    <Form actions={
                        <SpaceBetween direction='horizontal' size='xs'>
                            <Button onClick={exportToExcel} disabled={users.length === 0} style={{ root: btnIconForm }}><Icon path={mdiFileExcel} size={1} /></Button>
                            <Button style={{ root: btnIconForm }} onClick={() => {
                                handleRefresh()
                            }}><Icon path={mdiMagnify} size={1} /></Button>
                        </SpaceBetween>

                    }>
                        <SpaceBetween direction="vertical" size="s">
                            <FormField label={
                                <>
                                    Condición
                                    {/* Conditional logic to choose AND or OR icon/text */}
                                    {filter?.intersection === 1 ? (
                                        <span>{" "}
                                            <Link><Icon path={mdiVectorIntersection} size={0.75} />
                                                AND</Link>
                                        </span>
                                    ) : (
                                        <span>{" "}
                                            <Link><Icon path={mdiVectorUnion} size={0.75} />
                                                OR</Link>
                                        </span>
                                    )}
                                </>
                            }
                                constraintText={<>Defina si los filtros aplican como intersección (AND) o unión (OR)</>}
                            >
                                <Checkbox checked={filter?.intersection === 1} onChange={(e) => {
                                    setFilter({ ...filter, intersection: e.detail.checked ? 1 : 0 });
                                }}>Usar intersección de filtros</Checkbox>

                            </FormField>
                            <SpaceBetween direction="horizontal" size="s">
                                <div style={{ maxWidth: 250 }}>
                                    <FormField label="Estados">
                                        <Select
                                            onChange={(d) => {
                                                const newValue = d.detail.selectedOption.value;
                                                // Update state
                                                setFilter({ ...filter, isActiveUser: newValue === "-1" ? undefined : Number(newValue) });
                                            }}
                                            selectedOption={
                                                activeOptions.find((v) => v.value === (filter?.isActiveUser?.toString() ?? "-1"))
                                            }
                                            options={activeOptions}
                                        />

                                    </FormField>
                                </div>
                                <div style={{ maxWidth: 250 }}>
                                    <FormField label="Tipos">
                                        <SelectUserType value={filter?.idUserTypes ?? []} single={false} onSelect={(selected: number[]) => {
                                            setFilter({ ...filter, idUserTypes: selected });
                                        }}
                                            tokenLimit={0}
                                        />

                                    </FormField>
                                </div>
                                {/*
                     */}
                                <div style={{ maxWidth: 250 }}>
                                    <FormField label="Grupos">
                                        <SelectGroup
                                            single={false}
                                            tokenLimit={0}
                                            // Assuming mailTemplate.idGroups holds the array of selected group IDs
                                            value={filter?.idGroups ?? []}

                                            // 💡 FIX: onSelect must receive an array of ItemGroup objects
                                            onSelect={(selectedGroups: number[]) => {
                                                // Map the full objects back to an array of IDs (numbers) before setting state
                                                setFilter({
                                                    ...filter,
                                                    idGroups: selectedGroups
                                                });
                                            }}
                                        />

                                    </FormField>
                                </div>
                                <div style={{ maxWidth: 250 }}>
                                    <FormField label="Chequeos"><SelectCheck
                                        single={false}
                                        tokenLimit={0}
                                        value={filter?.idChecks ?? []}
                                        onSelect={(selectedChecks: number[]) => {
                                            setFilter({ ...filter, idChecks: selectedChecks });
                                        }} />

                                    </FormField>
                                </div>
                                <div style={{ maxWidth: 250 }}>
                                    <FormField label="Cargos">
                                        <SelectCharges
                                            single={false}
                                            tokenLimit={0}
                                            value={filter?.idCharges ?? []}
                                            onSelect={(selectedCharges: number[]) => {
                                                setFilter({
                                                    ...filter,
                                                    idCharges: selectedCharges //.map(charge => charge.idCharge)
                                                });
                                            }}
                                        />

                                    </FormField>
                                </div>
                            </SpaceBetween>
                        </SpaceBetween>
                    </Form>
                    {/* <FilteringUsers hasCharges hasUserTypes hasGroups hasChecks hasUserStatuses onSelect={(detail) => setFilter(detail)} />*/}
                    {users && users.length > 0 && (
                        <Table
                            stripedRows
                            variant="embedded"
                            onRowClick={({ detail }) => {
                            }}
                            filter={
                                <TextFilter
                                    filteringText={filteringText}
                                    onChange={(e) => setFilteringText(e.detail.filteringText)}
                                    filteringPlaceholder="Filtar usuario"
                                />
                            }

                            pagination={

                                <SpaceBetween direction="horizontal" size="xs" alignItems="center">
                                    {filtered.length > parameters.pageSize && (
                                        <Pagination
                                            currentPageIndex={currentPageIndex}
                                            pagesCount={Math.ceil(filtered.length / parameters.pageSize)}
                                            onChange={({ detail }) => setCurrentPageIndex(detail.currentPageIndex)}
                                        />
                                    )}

                                    {users.length > 0 && users.length > parameters.pageSize && (
                                        <SelectPaging onSelect={(pageSize) => {
                                            setCurrentPageIndex(1);
                                            setParameters({ ...parameters, pageSize: pageSize });
                                        }} />
                                    )}
                                </SpaceBetween>
                            }
                            columnDefinitions={[
                                /*
                                                                {
                                                                    id: 'idPhoto',
                                                                    header: '',
                                                                    cell: (item: ItemUser) => (
                                
                                                                        <UserAvatar idUser={item.idUser} />
                                                                    )
                                                                },
                                                                */
                                {
                                    id: 'idUser',
                                    header: 'ID',
                                    cell: (item: ItemUser) => (

                                        <FormField
                                            label={item.idUser}>
                                            <UserAvatar idUser={item.idUser} />
                                        </FormField>
                                    )
                                },
                                {
                                    id: 'displayName',
                                    header: 'Usuario',
                                    cell: (item: ItemUser) => (

                                        <FormField
                                            label={item.lastName}>
                                            {item.name}
                                        </FormField>
                                    )
                                },
                                {
                                    id: 'age',
                                    header: 'Edad',
                                    cell: (item: ItemUser) => (
                                        item.age
                                    )
                                },
                                {
                                    id: 'old',
                                    header: 'Antiguedad',
                                    cell: (item: ItemUser) => item.membership
                                },
                                {
                                    id: 'balance',
                                    header: 'Cuenta',
                                    cell: (item: ItemUser) => <FormField label={formatCurrency(item.balance, "CLP")}>
                                        {formatCurrency(item.balance45, "CLP")}
                                    </FormField>
                                },
                            ]}
                            items={paginated}
                        />
                    )}
                </SpaceBetween >
            }
        />
    );
};
